'use strict';

const $ = window.$ = window.jQuery = require('jquery');
const moment = global.moment = window.moment = require('moment');
const toastr = window.toastr = require('toastr');

const DataTable = require('datatables.net');
const Swal = require('sweetalert2');
const ClipboardJS = require('clipboard');
const Cookies = require('js-cookie');

window.Chart = require('chart.js');
window.Sortable = require('sortablejs').Sortable;

require('bootstrap');
require('bootstrap-daterangepicker');
require('datatables.net-buttons');
require('datatables.net-responsive');
require('datatables.net-rowreorder');
require('datatables.net-bs4');
require('select2/dist/js/select2.full.min');
require('jquery-tags-input/src/jquery.tagsinput');
require('pc-bootstrap4-datetimepicker');
require('ion-rangeslider');
require('multiselect-two-sides');

$.fn.dataTable = DataTable;
DataTable.$ = $;

//Main navigation
$.navigation = $('nav > ul.nav');

$.panelIconOpened = 'icon-arrow-up';
$.panelIconClosed = 'icon-arrow-down';

//Default colours
$.brandPrimary =  '#20a8d8';
$.brandSuccess =  '#4dbd74';
$.brandInfo =     '#63c2de';
$.brandWarning =  '#f8cb00';
$.brandDanger =   '#f86c6b';

$.grayDark =      '#2a2c36';
$.gray =          '#55595c';
$.grayLight =     '#818a91';
$.grayLighter =   '#d1d4d7';
$.grayLightest =  '#f8f9fa';

'use strict';

window.toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": true,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

/****
 * MAIN NAVIGATION
 */

$(document).ready(function ($) {

    $.navigation.find('.active').each(function () {
        $(this).parents('ul').add(this).each(function () {
            $(this).parent().addClass('open');
        });
    });

    $.navigation.on('click', 'a', function (e) {
        if ($.ajaxLoad) {
            e.preventDefault();
        }
        if ($(this).hasClass('nav-dropdown-toggle')) {
            $(this).parent().toggleClass('open');
            resizeBroadcast();
        }
    });

    /* ---------- Main Menu Open/Close, Min/Full ---------- */
    $('.sidebar-toggler').click(function () {
        $('body').toggleClass('sidebar-hidden');
        resizeBroadcast();
        saveState('sidebar-hidden');
    });

    $('.sidebar-minimizer').click(function () {
        $('body').toggleClass('sidebar-minimized');
        resizeBroadcast();
        saveState('sidebar-minimized');
    });

    $('.brand-minimizer').click(function () {
        $('body').toggleClass('brand-minimized');
        saveState('brand-minimized');
    });

    $('.mobile-sidebar-toggler').click(function () {
        $('body').toggleClass('sidebar-mobile-show');
        resizeBroadcast();
    });

    $('.sidebar-close').click(function () {
        $('body').toggleClass('sidebar-opened').parent().toggleClass('sidebar-opened');
    });

    $('a[href="#"][data-top!=true]').click(function (e) {
        e.preventDefault();
    });

    $('#modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let dialog = $('#modal .modal-dialog');
        dialog.removeClass('modal-lg');
        dialog.removeClass('modal-sm');

        if (button.data('size')) {
            dialog.addClass(button.data('size'));
        }

        $.get(button.data('action'), function (data) {
            dialog.html(data);

            $.each(button[0].dataset, function(key, value){
                if($.inArray(key, ["toggle", "target", "action", "size", "tab"]) === -1 && value !== ''){
                    let target = $('[name='+key+']');
                    if(typeof target === 'undefined') {
                        return;
                    }

                    if(target.data('plugin') === 'select2'){
                        target.findById(value);
                    } else {
                        target.val(value);
                    }
                }
            });

            if(button.data('tab')){
                $.tab = button.data('tab');
                $('.nav-tabs li#'+$.tab+' a').tab('show');
            }

            initPlugins();
        }).fail(function (error) {
            $('.modal-backdrop').remove();
            let message = (error.responseJSON && error.responseJSON.message) ? error.responseJSON.message : 'Request failed';
            toastr["error"](message)
        });

    }).on('hide.bs.modal', function () {
        $('#modal .modal-dialog').html('');
    });

    initPlugins();
});

$.fn.initSelect2 = function(){
    this.each(function() {
        let el = $(this);
        let ajax_url = el.data('action');
        let placeholder = el.data('placeholder');
        let min_input_length = (el.data('mininputlength') !== undefined) ? el.data('mininputlength') : 0;
        let min_results_for_search = el.data('minresultsforsearch');
        let exclude = (el.data('exclude') !== undefined) ? el.data('exclude') : '';
        let filters = (el.data('filters') !== undefined) ? el.data('filters') : '';
        let width = (el.data('width') !== undefined) ? el.data('width') : '100%';

        el.select2({
            ajax: {
                url: function () {
                    return ajax_url;
                },
                type: "POST",
                dataType: "json",
                delay: 250,
                data: function (params) {
                    let f = {};
                    $.each(filters.split('|'), function (key, value) {
                        if (value) {
                            f[value] = $('[name='+value+']').val();
                        }
                    });
                    return {
                        search: params.term,
                        exclude: exclude,
                        filters: f,
                        _token: $('meta[name="_token"]').attr('content')
                    };
                },
                cache: true
            },
            allowClear: true,
            width: width,
            containerCssClass: ':all:',
            minimumInputLength: min_input_length,
            minimumResultsForSearch: min_results_for_search,
            placeholder: {
                id: null,
                text: placeholder
            },
            theme: 'bootstrap'
        });
        return true;
    });
};

$.fn.findById = function(value){
    let select = $(this);
    if (!value) {
        return false;
    }
    if(select.data('plugin') === 'select2'){
        $.ajax({
            url: select.data('action'),
            type: "POST",
            dataType: "json",
            data: {
                'id': value,
                '_token': $('meta[name="_token"]').attr('content')
            }
        }).then(function (data) {
            if (data['results'].length) {
                let row = (data['results'][0]['children'] && data['results'][0]['children'].length) ? data['results'][0]['children'][0] : data['results'][0];
                let option = new Option(row['text'], row['id'], true, true);
                select.append(option).trigger({
                    type: 'select2:select',
                    params: {
                        data: data
                    }
                });
            }
            select.resetDependencies();
        });
    } else {
        select.val(value);
    }
};


$.fn.resetDependencies = function(){
    if($(this).data('dependencies')){
        $.each($(this).data('dependencies').split('|'), function (key, value) {
            if (value){
                $('[name=' + value + ']').val(null).trigger('change');
            }
        });
    }
};

$.fn.updateRow = function(file) {
    return new Promise((resolve, reject) => {
        let action = ($(this).data('action')) ? $(this).data('action') : '/';
        let method = ($(this).data('method')) ? $(this).data('method') : 'POST';

        let formData = new FormData();
        formData.append('_token', $('meta[name="_token"]').attr('content'));
        formData.append('_method', method);

        if ($(this).data('name')) {
            if (typeof $(this).data('value') !== "undefined") {
                formData.append($(this).data('name'), $(this).data('value'));
            } else if (file) {
                formData.append($(this).data('name'), file);
            } else {
                formData.append($(this).data('name'), $(this).val());
            }
        }

        window.request(action, undefined, formData).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        });
    });
};

function resizeBroadcast()
{
    let timesRun = 0;
    let interval = setInterval(function () {
        timesRun += 1;
        if (timesRun === 5) {
            clearInterval(interval);
        }
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            let evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        } else {
            window.dispatchEvent(new Event('resize'));
        }
    }, 62.5);
}

function saveState(c)
{
    if ($('body').hasClass(c)) {
        Cookies.set(c, true);
    } else {
        Cookies.remove(c);
    }
}

window.sortRows = function(rows, url)
{
    let formData = new FormData();
    formData.append('_token', $('meta[name="_token"]').attr('content'));
    formData.append('_method', 'POST');
    $.each(rows, function (key,value) {
        formData.append('data['+value.node.firstChild.textContent+']', value.newData);
    });
    window.request(url, undefined, formData);
};

window.request = function(action, $thisForm, formData) {
    return new Promise((resolve, reject) => {
        if (typeof $thisForm !== 'undefined') {
            formData = new FormData($thisForm[0]);
            let modalBody = $thisForm.find('.modal-body');

            $thisForm.find('.multiselect').each(function () {
                let name = $(this).attr('name');
                let options = $(this).find('option');
                options.each(function () {
                    formData.append(name, $(this).val());
                });
            });
        }

        $.ajax({
            type: "POST",
            url: action,
            data: formData,
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
        }).then(function (response, textStatus, jqXHR) {
            switch (jqXHR.status) {
                case 200:
                    toastr['success'](response.message);
                    if (response.action) {
                        window.location.replace(response.action);
                    } else if (response.remove_el) {
                        $(response.remove_el).fadeOut(300, function () {
                            $(this).remove(); });
                    } else if (response.hold) {
                        //
                    } else {
                        let modal = $('#modal');
                        if (typeof modal !== 'undefined') {
                            $('#modal').modal('hide');
                        }

                        let table = $("#datatable");
                        if ($.isFunction(table.DataTable)) {
                            table.DataTable().draw('page');
                        }
                    }
                    break;
                case 228:
                    requestCallback(response, action, $thisForm, formData);
                    break;
                case 222:
                    let data = '';
                    if (response.message) {
                        if (typeof modalBody !== "undefined") {
                            modalBody.prepend('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                        }
                        data += '<strong>'+response.message+'</strong>';
                    }
                    if (typeof response.errors !== 'undefined') {
                        $.each(response.errors,function (field, errors) {
                            if (typeof modalBody !== "undefined") {
                                modalBody.find('[name='+field+']').addClass('is-invalid');
                            }
                            $.each(errors,function (i, error) {
                                if (typeof modalBody !== "undefined") {
                                    modalBody.find('[name='+field+']').after('<div class="invalid-feedback">'+error+'</div>');
                                }
                                data += '<br /><strong>'+field+'</strong>: '+error;
                            });
                        });
                    }
                    if (data !== '') {
                        toastr["error"](data);
                    }
                    break;
                case 206:
                    if (typeof modalBody !== "undefined") {
                        modalBody.prepend('<div class="alert alert-info" role="alert">'+response.message+'</div>');
                    }
                    toastr["info"](response.message);
                    break;
            }
        }).fail(function (response) {
            let message = (typeof response.responseJSON !== 'undefined' && response.responseJSON.message) ? response.responseJSON.message : 'Request failed';
            if (typeof modalBody !== "undefined") {
                modalBody.prepend('<div class="alert alert-danger" role="alert">'+message+'</div>');
            } else {
                toastr["error"](message);
            }
        });
    });
};

function requestCallback(response, action, $thisForm, formData)
{
    Swal.fire({
        title: response.message.title,
        text: response.message.text,
        type: response.message.type,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: response.message.buttons.confirm,
        cancelButtonText: response.message.buttons.cancel,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger ml-4',
        buttonsStyling: false
    }).then(function (result) {
        if (result.value) {
            formData.append('_check', 1);
            window.request(action, $thisForm, formData);
        }
    });
}

window.calculatePrice = function(action)
{
    let formData = new FormData();
    formData.append('_token', $('meta[name="_token"]').attr('content'));
    formData.append('_method', 'POST');

    if ($("input[name=period]:not(:disabled)").val()) {
        formData.append('period', $("input[name=period]:not(:disabled)").val());
    }
    if ($("input[name=expired_at]:not(:disabled)").val()) {
        formData.append('expired_at', $("input[name=expired_at]:not(:disabled)").val());
    }
    if ($("input[name=old_expired_at]").val()) {
        formData.append('old_expired_at', $("input[name=old_expired_at]").val());
    }
    formData.append('plan_id', $("[name=plan_id]").val());
    formData.append('client_id', $("[name=client_id]").val());
    if ($("[name=for_free][type=checkbox]").is(":checked")) {
        formData.append('for_free', 1);
    }

    $.ajax({
        type: "POST",
        url: action,
        data: formData,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
    }).done(function (response) {
        $('#price').html(response.price);
        if (response.discount !== 0) {
            $('#discount').html(response.discount);
            $('#discount').parent().parent().parent().parent().fadeIn();
        } else {
            $('#discount').parent().parent().parent().parent().fadeOut();
            $('#discount').html('');
        }
    });
};


$(document).on('click', 'button#update_row', function () {
    $(this).updateRow();
});

$(document).on('click', 'img#upload_image', function () {
    let row = $(this);

    $('#fileupload')
        .unbind('change')
        .click()
        .change(function (event) {
            row.updateRow(event.target.files[0]);
        });
});

function initPlugins(){
    $('form.form-horizontal').each(function(){
        let $thisForm = $(this);
        let action = $thisForm[0].action;
        $thisForm.submit(function(e){
            e.preventDefault();
            $thisForm.find('.alert').each(function(){ $(this).remove(); });
            $thisForm.find('.is-invalid').each(function(){ $(this).removeClass('is-invalid'); });
            $thisForm.find('.invalid-feedback').each(function(){ $(this).remove(); });
            window.request(action, $thisForm);
        });
    });

    $('[data-plugin=select2]').each(function(){
        $(this).initSelect2();
        if($(this).data('dependencies')){
            $(this).on('change', function(){
                $(this).resetDependencies();
            });
        }
    });

    $('[data-plugin=daterange]').each(function(){
        $(this).daterangepicker({
            opens: 'left',
            autoUpdateInput: false,
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                "Last 7 days": [moment().subtract(6, 'days'), moment()],
                "Last 30 days": [moment().subtract(30, 'days'), moment()],
                "This month": [moment().startOf('month'), moment()],
                "Last month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                "This year": [moment().startOf('year'), moment()]
            },
        }).on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY')).trigger('change');
        });
    });

    $('[data-plugin=multiselect]').each(function(){
        $(this).multiselect({
            sort: false,
            search: {
                left: '<input type="text" name="q" class="form-control mb-2" placeholder="" />',
                right: '<input type="text" name="q" class="form-control mb-2" placeholder="" />',
            }
        });
    });

    $('[data-plugin=datetimepicker]').each(function(){
        let format = $(this).data('format');
        $(this).datetimepicker({
            locale: 'ru',
            format: format
        });
    });

    $('input[data-plugin=tags-input]').each(function(){
        $(this).tagsInput({
            autocomplete_url: $(this).data('action'),
            freeInput: false
        });
    });

    $('input[data-plugin=range-slider]').each(function(){
        let input = $(this);
        let action = input.data('action');
        $(this).ionRangeSlider({
            grid: true,
            from: 0,
            values: input.data('values'),
            prettify_enabled: true,
            prettify: function (num) {
                if (num === 0) {
                    return "test"
                } else if (num === 12) {
                    return "<strong>1</strong> year"
                } else {
                    return "<strong>"+num+"</strong> mo."
                }
            },
            onStart: function () {
                window.calculatePrice(action);
            },
            onFinish: function () {
                window.calculatePrice(action);
            }
        });
    });

    $('[data-plugin=clipboard]').click(function(){
        let block = $(this);
        let clip = new ClipboardJS(block[0], {
            text: function() {
                return block.html();
            }
        });
        clip.on('success', function() {
            window.toastr.success('Successfully copied to clipboard!');
        });
    });
}

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
    Array.from = (function () {
        let toStr = Object.prototype.toString;
        let isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        let toInteger = function (value) {
            let number = Number(value);
            if (isNaN(number)) {
                return 0; }
            if (number === 0 || !isFinite(number)) {
                return number; }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        let maxSafeInteger = Math.pow(2, 53) - 1;
        let toLength = function (value) {
            let len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */)
        {
            // 1. Let C be the this value.
            let C = this;

            // 2. Let items be ToObject(arrayLike).
            let items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }

            // 4. If mapfn is undefined, then let mapping be false.
            let mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            let T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            let len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method
            // of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            let A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            let k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            let kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            let o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            let len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            let n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y)
            {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}
